export enum Dialogs {
    none,
    signIn,
    signUp,
    forgotPassword,
    reserPassword,
    info,
    waitingRoom,
    gameRoom,
    playBlackCards,
    selectBlackCard,
    roundWinner,
    winner,
    survey,
    keyMoments,
    roast,
}